@if (navigatorService.setup(); as setup) {
  <div class="flex justify-center">
    <nav class="px-4 py-2 flex gap-2 items-stretch justify-center w-full md:w-auto">
      @if (setup.backLink) {
        <button
          @popup
          [routerLink]="setup.backLink.url"
          class="bg-cp-primary-60 btn-square px-4 md:px-6 py-4 self-center"
          [disabled]="setup.backLink.disabled"
        >
          <mat-icon svgIcon="cp-arrow-left" class="!h-8 !w-8"></mat-icon>
        </button>
      }

      @if (resolvedTemplate(); as htmlTemplate) {
        <div class="grid flex-1 md:flex-none">
          <ng-container @popup *ngTemplateOutlet="htmlTemplate"></ng-container>
        </div>
      } @else {
        @if (setup.info) {
          <div class="bg-cp-primary-60 hidden md:flex text-base font-bold rounded-lg" @popup>
            <div
              class="text-white flex items-center px-6 rounded-lg"
              [class.bg-cp-error-60]="showError()"
            >
              @if (showError()) {
                <mat-icon class="icon-info mr-2" svgIcon="cp-info" />
              }
              {{ setup.info }}
            </div>
          </div>
        }

        @if (navigatorService.setup()?.save) {
          <button
            @popup
            mat-flat-button
            (click)="navigatorService.setup()?.save?.action()"
            class="btn-secondary-lg !h-full !px-4 md:!px-6 btn-square flex-1 md:flex-none whitespace-nowrap"
          >
            {{ navigatorService.setup()?.save?.title }}
          </button>
        }
      }

      @if (setup.forward; as forwardSetup) {
        <button
          @popup
          class="bg-cp-secondary-100 btn-square px-4 md:px-6 py-4 text-white text-base font-bold"
          [routerLink]="prevInvalidSteps() || forwardSetup.disabled ? null : forwardSetup.url"
          (click)="forward(forwardSetup.action)"
          color="accent"
        >
          @if (forwardSetup.action?.label; as forwardlabel) {
            {{ forwardlabel }}
          } @else {
            <mat-icon svgIcon="cp-arrow-right" class="!h-8 !w-8 !mx-0"></mat-icon>
          }
        </button>
      }
    </nav>
  </div>
}
